module.exports = __webpack_public_path__ + "55bce78949b4d61858797c73c8df1e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/AccessPlace - Profile.png
// module id = 1037
// module chunks = 0